// extracted by mini-css-extract-plugin
export default {"entry":"PullRequestDiffsList-module__entry--SQtpu"};